import { Background, BackgroundVariant, Controls, ReactFlow, useReactFlow } from '@xyflow/react';
import { FC, memo, useEffect } from 'react';

import { ConnectionLine } from '@/lib/v3/components/Flows';

import { JourneySchema } from '@/src/modules/AutomationModuleNew/types/flowsTypes';

import '@xyflow/react/dist/style.css';
import './FlowCanvas.tailwind.css';

import {
  useManageHandleFlow,
  useTransformDataToFlow,
} from '@/modules/AutomationModuleNew/hooks/Flows';

interface FlowCanvasProps {
  journeySchema?: JourneySchema;
  children?: React.ReactNode;
}

const FlowCanvas: FC<FlowCanvasProps> = ({ journeySchema, children }) => {
  const { nodes: initialNodes, edges: initialEdges } = useTransformDataToFlow(journeySchema);

  const {
    nodes,
    edges,
    nodeTypes,
    edgeTypes,
    handleConnect,
    handleDragOver,
    handleDrop,
    onEdgesChange,
    onNodesChange,
    isValidConnection,
  } = useManageHandleFlow({ initialEdges, initialNodes });

  const { fitView } = useReactFlow();

  useEffect(() => {
    void fitView();
  }, [fitView]);

  console.log('NODES: ', nodes);
  console.log('EDGES: ', edges);

  return (
    <div className="journeys-flow-canvas size-full">
      <ReactFlow
        fitView
        connectionLineComponent={ConnectionLine}
        defaultEdgeOptions={{
          type: 'customEdge',
        }}
        edgeTypes={edgeTypes}
        edges={edges}
        isValidConnection={isValidConnection}
        nodeTypes={nodeTypes}
        nodes={nodes}
        onConnect={handleConnect}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onEdgesChange={onEdgesChange}
        onNodesChange={onNodesChange}
      >
        <Background bgColor="#F4F5FA" variant={BackgroundVariant.Dots} />
        <Controls />
        {children}
      </ReactFlow>
    </div>
  );
};

export default memo(FlowCanvas);
